import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useMember } from '../contexts/MemberContext';

/**
 * MemberRoute ensures there is valid member data in the context before rendering the protected route
 * If no member data is present, redirects to the landing page 
 */
const MemberRoute = () => {
  const { member } = useMember();

  // If no member data, redirect to landing page, otherwise render the child routes
  return member ? <Outlet /> : <Navigate to="/landing" replace />;
};

export default MemberRoute;